var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 169,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.909 124.205V40.723L130.957 0H38.814v124.205h.04l16.631 16.533 16.625-16.527 16.625 16.527 16.625-16.527 16.625 16.527 16.625-16.527 16.625 16.527 16.631-16.533h.043Z",
    fill: "#196CF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M171.5 40.723h-40.952V0L171.5 40.723Z",
    fill: "#56A4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M59.724 149.405c21.7 0 39.29-17.493 39.29-39.07 0-21.578-17.59-39.07-39.29-39.07s-39.29 17.492-39.29 39.07c0 21.577 17.59 39.07 39.29 39.07Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.724 149.405c21.7 0 39.29-17.493 39.29-39.07 0-21.578-17.59-39.07-39.29-39.07s-39.29 17.492-39.29 39.07c0 21.577 17.59 39.07 39.29 39.07Z",
    fill: "#fff",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.724 73.945c-20.211 0-36.595 16.292-36.595 36.39s16.384 36.39 36.595 36.39c20.21 0 36.595-16.292 36.595-36.39s-16.384-36.39-36.595-36.39Zm-41.985 36.39c0-23.058 18.797-41.75 41.985-41.75s41.985 18.692 41.985 41.75-18.797 41.75-41.985 41.75-41.985-18.692-41.985-41.75Z",
    fill: "#FFCA00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.86 136.054a2.67 2.67 0 0 1 0 3.79l-28.36 28.2a2.705 2.705 0 0 1-3.81 0 2.67 2.67 0 0 1 0-3.79l28.36-28.2a2.705 2.705 0 0 1 3.81 0Z",
    fill: "#FFCA00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.078 86.703a2.68 2.68 0 0 1 2.12 3.15l-3.546 17.773a2.694 2.694 0 0 1-3.168 2.107 2.68 2.68 0 0 1-2.119-3.15L51.91 88.81a2.694 2.694 0 0 1 3.168-2.107ZM72.512 85.822a2.68 2.68 0 0 1 2.114 3.154l-5.465 27.172a2.695 2.695 0 0 1-3.171 2.103 2.681 2.681 0 0 1-2.115-3.154l5.466-27.173a2.695 2.695 0 0 1 3.17-2.102Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m101.759 66.602.216-.187c5.284-.21 7.332-1.583 7.332-3.79v-.085c0-1.872-1.421-2.956-3.851-2.956-2.345 0-4.353.959-6.276 2.877l-3.851-4.21a13.227 13.227 0 0 1 4.632-3.383 13.293 13.293 0 0 1 5.637-1.11c6.031 0 10.133 3.08 10.133 8.617v.069c0 5.287-3.685 7.449-8.25 8.368v2.542h-5.705l-.017-6.752Zm2.932 9.991h.08c.888 0 1.74.351 2.368.976.628.624.981 1.471.981 2.355 0 .883-.353 1.73-.981 2.354a3.359 3.359 0 0 1-2.368.976h-.08c-.888 0-1.74-.351-2.368-.976a3.322 3.322 0 0 1-.981-2.355c0-.883.353-1.73.981-2.354a3.359 3.359 0 0 1 2.368-.976Z",
    fill: "#FCFCFC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.a080639150113f029c7944a599b43ed5.svg";
export { ForwardRef as ReactComponent };